module.exports = __webpack_public_path__ + "imgascvts/video.b5359e9f.png";